import * as React from 'react';

import { always } from '@kofno/piper';
import { observer } from 'mobx-react';
import MapWithSeparator from '../MapWithSeparator';
import Divider from './Divider';
import { WizardStepItem } from './Types';
import WizardStep from './WizardStep';

interface Props {
  items: WizardStepItem[];
}

const WizardSteps: React.FC<Props> = ({ items }) => (
  <MapWithSeparator
    dividerFn={always(<Divider />)}
    mapFn={({ label, step, state }) => (
      <WizardStep key={label} state={state} step={step} label={label} />
    )}
    items={items}
  />
);

export default observer(WizardSteps);
